































































import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin'

export default BaseCmsBlock.extend({
  name: "SpecialsMenuBlock",

  data() {
    return {
      windowWidth: null,
    }
  },
  computed: {
    isMobile: function() {
      if (!process.client) {
        return false
      }
      return this.windowWidth < 1000
    },
  },
  methods: {
    handlerWindowWidth: function () {
      this.windowWidth = window.innerWidth;
    }
  },
  mounted: function() {
    window.addEventListener('resize', this.handlerWindowWidth);
    this.handlerWindowWidth();
  },
  unMounted: function() {
    window.removeEventListener('resize', this.handlerWindowWidth);
  }
});
